/**
 * Helper function that validates that the provided argument is neither 'undefined' nor 'null',
 * throws an error otherwise
 * @param value the value to validate
 * @returns the original value
 */
export function assertDefined<T>(value: T | undefined | null): T {
  if (value === undefined || value === null) {
    throw new Error("Assertion error: Unexpected undefined or null value");
  }
  return value;
}
